// @flow

import type { RequestPromise } from '@insolus/request';

export type ArticleType = 'machines' | 'reportages' | 'dossiers';

export type Article = {|
    id: number,
    title: {|
        rendered: string
    |},
    content: {|
        rendered: string
    |},
    link: string,
    _embedded: {|
        'wp:featuredmedia': [
            {|
                'source_url': string
            |}
        ]
    |},
    date: string
|};

const all = (type: ArticleType, limit: number): RequestPromise<Article[]> => {
    const requestPromise = fetch(
        `https://www.chantiersmagazine.ch/wp-json/wp/v2/${type}?per_page=${limit}&_embed`
    );

    const promise: any = requestPromise.then(response => response.json());

    promise.abort = () => {};

    return (promise: RequestPromise<Article[]>);
};

export default { all };
